import * as React from 'react'
import type { SVGProps } from 'react'
const SvgVote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={30}
    height={31}
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4.03169C2 3.04398 2.81229 2.23169 3.8 2.23169H17.8C18.7877 2.23169 19.6 3.04398 19.6 4.03169C19.6 4.58398 20.0477 5.03169 20.6 5.03169C21.1523 5.03169 21.6 4.58398 21.6 4.03169C21.6 1.93941 19.8923 0.231689 17.8 0.231689H3.8C1.70772 0.231689 0 1.93941 0 4.03169V18.0317C0 20.124 1.70772 21.8317 3.8 21.8317C4.35229 21.8317 4.8 21.384 4.8 20.8317C4.8 20.2794 4.35229 19.8317 3.8 19.8317C2.81229 19.8317 2 19.0194 2 18.0317V4.03169ZM12.2 10.6317C11.2059 10.6317 10.4 11.4376 10.4 12.4317V26.4317C10.4 27.4258 11.2059 28.2317 12.2 28.2317H26.2001C27.1942 28.2317 28.0001 27.4258 28.0001 26.4317V12.4317C28.0001 11.4376 27.1942 10.6317 26.2001 10.6317H12.2ZM8.40002 12.4317C8.40002 10.333 10.1013 8.6317 12.2 8.6317H26.2001C28.2987 8.6317 30.0001 10.333 30.0001 12.4317V26.4317C30.0001 28.5304 28.2987 30.2317 26.2001 30.2317H12.2C10.1013 30.2317 8.40002 28.5304 8.40002 26.4317V12.4317ZM24.1071 15.9246C24.4976 16.3151 24.4976 16.9483 24.1071 17.3388L18.5071 22.9388C18.1166 23.3294 17.4834 23.3294 17.0929 22.9388L14.2929 20.1388C13.9024 19.7483 13.9024 19.1151 14.2929 18.7246C14.6834 18.3341 15.3166 18.3341 15.7071 18.7246L17.8 20.8175L22.6929 15.9246C23.0834 15.5341 23.7166 15.5341 24.1071 15.9246Z"
      fill="#FEBD98"
    />
  </svg>
)
export default SvgVote
